export const CHANGE_LOCALE = "CHANGE_LOCALE";

export const changeLocale = (localeCode) => ({
  type: CHANGE_LOCALE,
  code: localeCode
});
